// extracted by mini-css-extract-plugin
module.exports = {"flashLinkWrapper":"styles_flashLinkWrapper__Syy__","flashLink":"styles_flashLink__eyuJx","flashLink__icon":"styles_flashLink__icon__LbFG7"};